/**
 * @file Main.js
 *
 * Instantiates classes in a specific order.
 *
 * @author Richie Brondenstein <richie@studyportals.com>
 * @author Stanley Clark <stanley@studyportals.com>
 * @author Steve Zeeuwe <steve@studyportals.com>

 * @copyright © 2017 StudyPortals B.V., all rights reserved.
 * @version 1.0.1
 */
import { UrlHandler } from './Search/UrlHandler';
import { AutoCompleteControllerGeneric } from '../../../Modules/AutoComplete/JS/AutoCompleteController.js';

class Main {
	/**
	 * Main constructor
	 *
	 * Only instantiate the generic controllers on non-search pages.
	 * The search page has its own controllers in SearchController.js.
	 */

	constructor() {
		if (!UrlHandler.isSearchPage()) {
			this.autoCompleteController = new AutoCompleteControllerGeneric(window.Loot.DataStorage);
		}
	}
}

if (typeof window.StudyPortals === 'undefined') {
	window.StudyPortals = {
		main: new Main()
	};
} else {
	window.StudyPortals.main = new Main();
}
